let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("83ZKS")).then(() => parcelRequire('6h5im'));